// extracted by mini-css-extract-plugin
export default {"link":"InAppLink_link__Aqcr7","disabledLink":"InAppLink_disabledLink__V95sq"};